// extracted by mini-css-extract-plugin
export default {"Calendar":"XCaS6","Calendar--hasTime":"_3-Si0","Calendar--withoutMonthsNavigation":"-dx3X","Calendar--isMobile":"jSb4B","skeleton-progress":"aouje"};